
import { useEffect, useRef, useState } from "react";
import ResCon from "../../Extra/Rescon";

const TableRecord = ((props) => {
    return (
        <>
            {props.type == 1 && <Direction data={props.data} />}
            {props.type == 2 && <LineTable data={props.data} />}
            {props.type == 3 && <OddEvenTable data={props.data} />}
            {props.type == 4 && <RunTypeTable data={props.data} />}
        </>
    )
});

const Direction = ((props) => {
    const [data, setData] = useState(props.data);
    const [loops, setLoops] = useState([]);
    const [settedW, setW] = useState(0);
    const [long, setLong] = useState();
    const [stats, setStats] = useState();

    const tableRef = useRef();

    useEffect(() => {
        SortData(data);
    }, [data]);

    useEffect(() => {
        if (!tableRef) return;
        tableRef.current.scrollLeft = settedW;
    }, [props, settedW]);


    const SortData = ((data) => {

        let summarizeArr = [];

        let containerArr = [];

        let lastResult = null;

        let width = 0;
        let len = 0;
        let long = 0;

        let param1 = 0;
        let param2 = 0;

        let red = 1;
        let blue = 1;

        let maxRed = 0;
        let maxBlue = 0;


        data.map((item, index) => {

            let type = item['ball_1'] % 2 == 0 ? 0 : 1;

            if (lastResult == null) {
                containerArr.push(item);
                lastResult = type;
                len++;

                if (type == 1) {
                    red++;
                    param2++;
                }

                if (type == 0) {
                    blue++
                    param1++;
                }

                return;
            }


            if (type == 1) {
                param2++;
            }

            if (type == 0) {
                param1++;
            }


            if (lastResult == type) {

                containerArr.push(item);

                len++;

                if (type == 1) {
                    red++;
                }

                if (type == 0) {
                    blue++;
                }

            } else {

                containerArr.range = len;
                summarizeArr.push(containerArr)
                containerArr = [];
                containerArr.push(item);
                width += 50;

                if (long < len) {
                    long = len;
                }

                len = 0;

                if (blue > maxBlue) {
                    maxBlue = blue;
                }

                if (red > maxRed) {
                    maxRed = red;
                }

                blue = 1;
                red = 1;
            }

            lastResult = type;

        });

        if (containerArr) {
            containerArr.range = len;
            summarizeArr.push(containerArr);
            width += 50;
        }

        let stats =
        {
            total_odd: param1,
            total_even: param2,
            odd_percentage: (param1 / (param1 + param2)) * 100,
            even_percentage: (param2 / (param1 + param2)) * 100,
            max_odd: maxRed,
            max_even: maxBlue,
        };

        setStats(stats);
        setW(width);
        setLoops(summarizeArr);
        setLong(long);
    });


    return (
        <>
            <ResOddEven data={stats} name1={"좌"} name2={"우"} />
            <div className="res-main-wrapper" ref={tableRef}>
                <div className="result-table-wrapper" style={{ width: settedW + 'px' }}>
                    {loops.map((item, index) => (
                        <div className="res-cont" key={index}>

                            <div className="child-cont">
                                {item[0]['ball_1'] % 2 == 0 && <span className="text-red">우</span>}
                                {item[0]['ball_1'] % 2 != 0 && <span className="text-blue">좌</span>}
                            </div>

                            {item.map((i, x) => (
                                <div className="child-cont" key={x}><ResCon type={i['ball_1'] % 2 == 0 ? 'r' : 'b'} text={i.round} /></div>
                            ))}

                            {CreateEmptyBox((long + 1) - item.length)}
                            <div className="child-cont">
                                {item.range == 0 && 1}
                                {item.range > 0 && item.range + 1}
                            </div>
                            <div className="child-cont">{index + 1}</div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
});

const LineTable = ((props) => {
    const [data, setData] = useState(props.data);
    const [loops, setLoops] = useState([]);
    const [settedW, setW] = useState(0);
    const [long, setLong] = useState();
    const [stats, setStats] = useState();

    const tableRef = useRef();

    useEffect(() => {
        SortData(data);
    }, [data]);

    useEffect(() => {
        if (!tableRef) return;
        tableRef.current.scrollLeft = settedW;
    }, [props, settedW]);


    const SortData = ((data) => {

        let summarizeArr = [];

        let containerArr = [];

        let lastResult = null;

        let width = 0;
        let len = 0;
        let long = 0;

        let param1 = 0;
        let param2 = 0;

        let red = 1;
        let blue = 1;

        let maxRed = 0;
        let maxBlue = 0;


        data.map((item, index) => {

            let type = item['ball_1'] <= 14 ? 0 : 1;

            if (lastResult == null) {
                containerArr.push(item);
                lastResult = type;
                len++;

                if (type == 1) {
                    red++;
                    param2++;
                }

                if (type == 0) {
                    blue++
                    param1++;
                }

                return;
            }


            if (type == 1) {
                param2++;
            }

            if (type == 0) {
                param1++;
            }


            if (lastResult == type) {

                containerArr.push(item);

                len++;

                if (type == 1) {
                    red++;
                }

                if (type == 0) {
                    blue++;
                }

            } else {

                containerArr.range = len;
                summarizeArr.push(containerArr)
                containerArr = [];
                containerArr.push(item);
                width += 50;

                if (long < len) {
                    long = len;
                }

                len = 0;

                if (blue > maxBlue) {
                    maxBlue = blue;
                }

                if (red > maxRed) {
                    maxRed = red;
                }

                blue = 1;
                red = 1;
            }

            lastResult = type;

        });

        if (containerArr) {
            containerArr.range = len;
            summarizeArr.push(containerArr);
            width += 50;
        }

        let stats =
        {
            total_odd: param1,
            total_even: param2,
            odd_percentage: (param1 / (param1 + param2)) * 100,
            even_percentage: (param2 / (param1 + param2)) * 100,
            max_odd: maxRed,
            max_even: maxBlue,
        };

        setStats(stats);
        setW(width);
        setLoops(summarizeArr);
        setLong(long);
    });


    return (
        <>
            <ResOddEven data={stats} name1={"3"} name2={"4"} />
            <div className="res-main-wrapper" ref={tableRef}>
                <div className="result-table-wrapper" style={{ width: settedW + 'px' }}>
                    {loops.map((item, index) => (
                        <div className="res-cont" key={index}>

                            <div className="child-cont">
                                {item[0]['ball_1'] > 14 && <span className="text-red">4</span>}
                                {item[0]['ball_1'] <= 14 && <span className="text-blue">3</span>}
                            </div>

                            {item.map((i, x) => (
                                <div className="child-cont" key={x}><ResCon type={i['ball_1'] > 14 ? 'r' : 'b'} text={i.round} /></div>
                            ))}

                            {CreateEmptyBox((long + 1) - item.length)}
                            <div className="child-cont">
                                {item.range == 0 && 1}
                                {item.range > 0 && item.range + 1}
                            </div>
                            <div className="child-cont">{index + 1}</div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
});

const OddEvenTable = ((props) => {
    const [data, setData] = useState(props.data);
    const [loops, setLoops] = useState([]);
    const [settedW, setW] = useState(0);
    const [long, setLong] = useState();
    const [stats, setStats] = useState();

    const tableRef = useRef();

    useEffect(() => {
        SortData(data);
    }, [data]);

    useEffect(() => {
        if (!tableRef) return;
        tableRef.current.scrollLeft = settedW;
    }, [props, settedW]);


    const SortData = ((data) => {

        let summarizeArr = [];

        let containerArr = [];

        let lastResult = null;

        let width = 0;
        let len = 0;
        let long = 0;

        let param1 = 0;
        let param2 = 0;

        let red = 1;
        let blue = 1;

        let maxRed = 0;
        let maxBlue = 0;


        data.map((item, index) => {

            let type = null;

            // RIGHT | 3LINE
            if (item.ball_1 % 2 != 0 && item.ball_1 <= 14) {
                type = 1;
            }

            // LEFT | 3LINE
            if (item.ball_1 % 2 == 0 && item.ball_1 <= 14) {
                type = 0;
            }

            // RIGHT | 4LINE
            if (item.ball_1 % 2 != 0 && item.ball_1 > 14) {
                type = 0;

            }

            // LEFT | 4LINE
            if (item.ball_1 % 2 == 0 && item.ball_1 > 14) {
                type = 1;
            }

            if (lastResult == null) {
                containerArr.push(item);
                lastResult = type;
                len++;

                if (type == 1) {
                    red++;
                    param2++;
                }

                if (type == 0) {
                    blue++
                    param1++;
                }

                return;
            }


            if (type == 1) {
                param2++;
            }

            if (type == 0) {
                param1++;
            }


            if (lastResult == type) {

                containerArr.push(item);

                len++;

                if (type == 1) {
                    red++;
                }

                if (type == 0) {
                    blue++;
                }

            } else {

                containerArr.range = len;
                summarizeArr.push(containerArr)
                containerArr = [];
                containerArr.push(item);
                width += 50;

                if (long < len) {
                    long = len;
                }

                len = 0;

                if (blue > maxBlue) {
                    maxBlue = blue;
                }

                if (red > maxRed) {
                    maxRed = red;
                }

                blue = 1;
                red = 1;
            }

            lastResult = type;

        });

        if (containerArr) {
            containerArr.range = len;
            summarizeArr.push(containerArr);
            width += 50;
        }

        let stats =
        {
            total_odd: param1,
            total_even: param2,
            odd_percentage: (param1 / (param1 + param2)) * 100,
            even_percentage: (param2 / (param1 + param2)) * 100,
            max_odd: maxRed,
            max_even: maxBlue,
        };

        setStats(stats);
        setW(width);
        setLoops(summarizeArr);
        setLong(long);
    });


    return (
        <>
            <ResOddEven data={stats} name1={"홀"} name2={"짝"} />
            <div className="res-main-wrapper" ref={tableRef}>
                <div className="result-table-wrapper" style={{ width: settedW + 'px' }}>
                    {loops.map((item, index) => (
                        <div className="res-cont" key={index}>

                            <div className="child-cont">
                                {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] <= 14) && <span className="text-red">짝</span>}
                                {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] <= 14) && <span className="text-blue">홀</span>}
                                {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] > 14) && <span className="text-blue">홀</span>}
                                {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] > 14) && <span className="text-red">짝</span>}
                            </div>

                            {item.map((i, x) => (
                                <div className="child-cont" key={x}>
                                    {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] <= 14) && <ResCon type={'r'} text={i.round} />}
                                    {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] <= 14) && <ResCon type={'b'} text={i.round} />}
                                    {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] > 14) && <ResCon type={'b'} text={i.round} />}
                                    {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] > 14) && <ResCon type={'r'} text={i.round} />}

                                </div>
                            ))}

                            {CreateEmptyBox((long + 1) - item.length)}
                            <div className="child-cont">
                                {item.range == 0 && 1}
                                {item.range > 0 && item.range + 1}
                            </div>
                            <div className="child-cont">{index + 1}</div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
});

const RunTypeTable = ((props) => {
    const [data, setData] = useState(props.data);
    const [loops, setLoops] = useState([]);
    const [settedW, setW] = useState(0);
    const [long, setLong] = useState();
    const [stats, setStats] = useState();

    const tableRef = useRef();

    useEffect(() => {
        SortData(data);
    }, [data]);

    useEffect(() => {
        if (!tableRef) return;
        tableRef.current.scrollLeft = settedW;
    }, [props, settedW]);


    const SortData = ((data) => {

        let summarizeArr = [];

        let containerArr = [];

        let lastResult = null;

        let width = 0;
        let len = 0;
        let long = 0;

        let param1 = 0;
        let param2 = 0;

        let red = 1;
        let blue = 1;

        let maxRed = 0;
        let maxBlue = 0;

        let param3 = 0;
        let param4 = 0;

        let red2 = 1;
        let blue2 = 1;

        let maxRed2 = 0;
        let maxBlue2 = 0;



        data.map((item, index) => {

            let type = null;




            // RIGHT | 4LINE
            if (item.ball_1 % 2 != 0 && item.ball_1 > 14) {
                type = 1;
            }

            // LEFT | 3LINE
            if (item.ball_1 % 2 == 0 && item.ball_1 <= 14) {
                type = 2;
            }

            // RIGHT | 3LINE
            if (item.ball_1 % 2 != 0 && item.ball_1 <= 14) {
                type = 3;
            }

            // LEFT | 4LINE
            if (item.ball_1 % 2 == 0 && item.ball_1 > 14) {
                type = 4;
            }


            if (lastResult == null) {
                containerArr.push(item);
                lastResult = type;
                len++;

                if (type == 1) {
                    blue++;
                    param1++;
                }

                if (type == 2) {
                    blue2++;
                    param2++;
                }

                if (type == 3) {
                    red++;
                    param3++;
                }

                if (type == 4) {
                    red2++;
                    param4++;
                }

                return;
            }


            if (type == 1) {
                param1++;
            }

            if (type == 2) {

                param2++;
            }

            if (type == 3) {
                param3++;
            }

            if (type == 4) {
                param4++;
            }


            if (lastResult == type) {

                containerArr.push(item);

                len++;

                if (type == 1) {
                    blue++;
                }

                if (type == 2) {
                    blue2++;
                }

                if (type == 3) {
                    red++;
                }

                if (type == 4) {
                    red2++;
                }

            } else {

                containerArr.range = len;
                summarizeArr.push(containerArr)
                containerArr = [];
                containerArr.push(item);
                width += 50;

                if (long < len) {
                    long = len;
                }

                len = 0;

                if (blue > maxBlue) {
                    maxBlue = blue;
                }

                if (red > maxRed) {
                    maxRed = red;
                }

                if (red2 > maxRed2) {
                    maxRed2 = red2;
                }

                if (blue2 > maxBlue2) {
                    maxBlue2 = blue2;
                }

                blue = 1;
                red = 1;
                blue2 = 1;
                red2 = 1;
            }

            lastResult = type;

        });

        if (containerArr) {
            containerArr.range = len;
            summarizeArr.push(containerArr);
            width += 50;
        }

        let stats =
        {
            total_blue: param1,
            total_blue2: param2,
            total_red: param3,
            total_red2: param4,
            blue_per: (param1 / (param1 + param2 + param3 + param4)) * 100,
            blue2_per: (param2 / (param1 + param2 + param3 + param4)) * 100,
            red_per: (param3 / (param1 + param2 + param3 + param4)) * 100,
            red2_per: (param4 / (param1 + param2 + param3 + param4)) * 100,
            maxRed: maxRed,
            maxBlue: maxBlue,
            maxRed2: maxRed2,
            maxBlue2: maxBlue2,
        };

        setStats(stats);
        setW(width);
        setLoops(summarizeArr);
        setLong(long);
    });


    return (
        <>
            <ResType data={stats} name1={"홀"} name2={"짝"} />
            <div className="res-main-wrapper" ref={tableRef}>
                <div className="result-table-wrapper" style={{ width: settedW + 'px' }}>
                    {loops.map((item, index) => (
                        <div className="res-cont" key={index}>

                            <div className="child-cont">
                                {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] <= 14) && <span className="text-red"> 좌3짝</span>}
                                {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] <= 14) && <span className="text-blue">우3홀</span>}
                                {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] > 14) && <span className="text-blue">좌4홀</span>}
                                {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] > 14) && <span className="text-red">우4짝</span>}
                            </div>

                            {item.map((i, x) => (
                                <div className="child-cont" key={x}>
                                    {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] <= 14) && <ResCon type={'r'} text={i.round} />}
                                    {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] <= 14) && <ResCon type={'b'} text={i.round} />}
                                    {(item[0]['ball_1'] % 2 != 0 && item[0]['ball_1'] > 14) && <ResCon type={'b'} text={i.round} />}
                                    {(item[0]['ball_1'] % 2 == 0 && item[0]['ball_1'] > 14) && <ResCon type={'r'} text={i.round} />}
                                </div>
                            ))}

                            {CreateEmptyBox((long + 1) - item.length)}
                            <div className="child-cont">
                                {item.range == 0 && 1}
                                {item.range > 0 && item.range + 1}
                            </div>
                            <div className="child-cont">{index + 1}</div>
                        </div>
                    ))}
                </div>
            </div>
        </>
    )
});





const CreateEmptyBox = ((count) => {

    let content = [];
    for (let i = 0; i < count; i++) {

        content.push(<div className="child-cont" key={i}></div>);
    }
    return content;
});


const ResOddEven = ((props) => {

    let [res, setRes] = useState();

    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (props.data) {
            setRes(props.data);
            setMounted(true);
        }
    }, [props]);

    if (!mounted) return;

    return (
        <>
            <ul className="result-indicator">
                <li>
                    <div className="status-holder">
                        <ResCon type="b" text={props.name1} />
                        <label>{res.total_odd}좌</label>
                        <span>({res.odd_percentage.toFixed(2)}%)</span>
                        <small>{res.max_odd}연속</small>
                    </div>
                </li>
                <li>
                    <div className="status-holder">
                        <ResCon type="r" text={props.name2} />
                        <label>{res.total_even}번</label>
                        <span>({res.even_percentage.toFixed(2)}%)</span>
                        <small>{res.max_odd}연속</small>
                    </div>
                </li>
            </ul>
        </>
    )
});



const ResType = ((props) => {

    let [res, setRes] = useState();
    const [mounted, setMounted] = useState(false);

    useEffect(() => {
        if (props.data) {
            setRes(props.data);
            setMounted(true);
        }
    }, [props]);

    if (!mounted) return;

    return (
        <>
            <ul className="result-indicator">

                <li>
                    <div className="status-holder">
                        <ResCon type="b" text="좌4홀" />
                        <label>{res.total_blue}좌</label>
                        <span>({res.blue_per.toFixed(2)}%)</span>
                        <small>{res.maxBlue}연속</small>
                    </div>
                </li>

                <li>
                    <div className="status-holder">
                        <ResCon type="b" text="우3홀" />
                        <label>{res.total_blue2}좌</label>
                        <span>({res.blue2_per.toFixed(2)}%)</span>
                        <small>{res.maxBlue2}연속</small>
                    </div>
                </li>
                <li>
                    <div className="status-holder">
                        <ResCon type="r" text="좌3짝" />
                        <label>{res.total_red}좌</label>
                        <span>({res.red_per.toFixed(2)}%)</span>
                        <small>{res.maxRed}연속</small>
                    </div>
                </li>
                <li>
                    <div className="status-holder">
                        <ResCon type="r" text="우4짝" />
                        <label>{res.total_red2}좌</label>
                        <span>({res.red2_per.toFixed(2)}%)</span>
                        <small>{res.maxRed2}연속</small>
                    </div>
                </li>

            </ul>
        </>
    )
});




export default TableRecord;